<template>
  <div v-if="userRole !== 'guest'">
    <div class="innerItem">
      <button type="button" class="btn btnFull btnPrimary" @click="onSave">{{locale.save}}</button>
    </div>
    <div class="innerItem">
      <button type="button" class="btn btnFull" @click="setOrder">{{locale.amenity_order}}</button>
    </div>
    <SetOrder v-if="order"
      :locale="locale"
      @close="setOrder" />
    <!-- v.2:: submitTo: system_amenity2 -->
    <div v-if="!setting.integration" class="innerItem">
      <div class="label mb5 setLabel">{{locale.integration_version}}</div>
      <p class="sysMessage">{{locale.amenity_integration_message_1}}<br>{{locale.amenity_integration_message_2}}</p>
      <div class="mt10">
        <div class="checkbox">
          <input type="checkbox" id="amenity_integration" v-model="setting.integration" />
          <label for="amenity_integration">{{locale.apply_integration_version}}</label>
        </div>
      </div>
    </div>
    <!-- //v.2:: submitTo: system_amenity2 -->
    <!-- 한번에 요청 가능한 항목수 -->
    <div v-if="setting.integration">
      <div class="innerItem">
        <label class="label mb5 setLabel">{{locale.activate_cart}}</label>
        <div class="mt10">
          <div class="checkbox">
            <input type="checkbox" id="amenity_cart" v-model="setting.cart" />
            <label for="amenity_cart">{{locale.activate}}</label>
          </div>
        </div>
      </div>
      <div class="innerItem">
        <label class="label mb5 setLabel">{{locale.item_limit}}</label>
        <div class="mt10">
          <div class="checkbox">
            <input type="checkbox" id="amenity_itemLimity" v-model="setting.itemLimitActive" />
            <label for="amenity_itemLimity">{{locale.apply_limit}}</label>
          </div>
          <div v-if="setting.itemLimitActive" class="mt15">
            <label class="label mb5 setSubLabel">{{locale.item_limit_number}}</label>
            <input type="text" class="optionValue input" @input="inputNumber('itemLimit')" v-model="setting.itemLimit">
          </div>
        </div>
      </div>
    </div>
    <!-- //한번에 요청 가능한 항목수 -->
    <!-- 요청 제한 -->
    <div v-if="setting.integration" class="innerItem">
      <div class="label mb5 setLabel">
        {{locale.order_limit}}
        <button type="button" class="btn btnWhite sizeXs" @click="applyAll('limit')">{{locale.apply_all}}</button>
      </div>
      <div>
        <div class="checkbox">
          <input type="checkbox" id="amenity_limitActive" v-model="setting.orderLimitActive" />
          <label for="amenity_limitActive">{{locale.apply_limit}}</label>
        </div>
      </div>
      <!-- 기간, 횟수 -->
      <div v-if="setting.orderLimitActive">
        <div class="mt15">
          <label class="label mb5 setSubLabel">{{locale.order_limit_term}}</label>
          <div class="limitDay">
            <div class="checkbox radio">
              <input type="radio" name="amenity_orderLimit" id="amenity_orderLimit_day" value="day" v-model="setting.orderLimit" />
              <label for="amenity_orderLimit_day">1{{locale.day}}</label>
              <Datetime type="time"
                v-model="limitTime"
                input-class="limitTime"
                :minute-step="1" />
              Reset time
            </div>
          </div>
          <div class="mt5">
            <div class="checkbox radio">
              <input type="radio" name="amenity_orderLimit" id="amenity_orderLimit_ota" value="ota" v-model="setting.orderLimit" />
              <label for="amenity_orderLimit_ota">{{locale.stay_period}}</label>
            </div>
          </div>
        </div>
        <div class="mt15">
          <label class="label mb5 setSubLabel">{{locale.order_number}}</label>
          <input type="text" class="optionValue input" @input="inputNumber('orderMax')" v-model="setting.orderMax">
        </div>
        <div class="mt15">
          <label class="label setSubLabel">{{locale.amenity_limit_message}}</label>
          <div class="mt5"><p class="sysMessage">{{locale.message_amenity_limit_message}}</p></div>
          <div class="translation">
            <input v-model="setting.orderLimitMessage[lang.default]" type="text" class="input" @focusout="setDefaultVal('orderLimitMessage')">
            <button type="button" class="btnTranslation" :title="locale.language_specific_set" @click.stop="onLangValueOpen('orderLimitMessage')">
              <span class="blind">{{locale.language_specific_set}}</span>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="512" height="512"><g id="outline"><path d="M71.008,183.859,99,206.25A8,8,0,0,0,112,200V176h34c-.1.146-.226.283-.329.43a136.11,136.11,0,0,0,57.883,205.109c.211.086.429.164.648.234A135.616,135.616,0,0,0,256,392a137.9,137.9,0,0,0,24-2.129V440a32.032,32.032,0,0,0,32,32H424a32.032,32.032,0,0,0,32-32V367.383a39.852,39.852,0,0,0-15.008-31.242L413,313.75A8,8,0,0,0,400,320v24H359.5c2.225-2.613,4.472-5.211,6.491-7.976.031-.04.064-.076.1-.117s.057-.067.083-.1A136.03,136.03,0,0,0,256,120a137.9,137.9,0,0,0-24,2.129V80a32.032,32.032,0,0,0-32-32H88A32.032,32.032,0,0,0,56,80v72.617A39.852,39.852,0,0,0,71.008,183.859ZM408,360a8,8,0,0,0,8-8V336.641l14.992,11.992A23.906,23.906,0,0,1,440,367.383V440a16.021,16.021,0,0,1-16,16H312a16.021,16.021,0,0,1-16-16V376a16.021,16.021,0,0,1,16-16Zm-85.725-16q1.952-7.046,3.563-14.112Q335.9,332.2,346,335.273c-2.692,3.055-5.56,5.948-8.55,8.727Zm34.063-22.282q-13.658-4.4-27.277-7.5A324.916,324.916,0,0,0,334.2,264h41.5A119.068,119.068,0,0,1,356.338,321.718Zm.145-131.214A118.789,118.789,0,0,1,375.691,248H334.2a323.384,323.384,0,0,0-5.125-50.036Q342.938,194.822,356.483,190.5Zm-10.277-13.583q-10.067,3.023-20.317,5.362-3.323-14.64-8.128-29.137A119.3,119.3,0,0,1,346.206,176.921ZM264,136.314a119.479,119.479,0,0,1,33.258,7.09,298.5,298.5,0,0,1,12.961,42.11A310.41,310.41,0,0,1,264,190.167Zm0,69.881a326.175,326.175,0,0,0,49.4-5,307.007,307.007,0,0,1,4.8,46.8H264ZM264,264H318.2a308.575,308.575,0,0,1-4.8,46.941A326.084,326.084,0,0,0,264,305.829Zm0,57.831a310.731,310.731,0,0,1,46.176,4.783q-2.089,9.087-4.726,18.071a31.955,31.955,0,0,0-25.195,28.8A118.573,118.573,0,0,1,264,375.64ZM155.512,190.512q12.942,4.15,25.833,7.111A325.253,325.253,0,0,0,176.2,248H136.309A118.879,118.879,0,0,1,155.512,190.512Zm10.257-13.577q.415-.468.838-.935h19.317c-.5,2-.951,3.96-1.406,5.941Q175.164,179.765,165.769,176.935ZM155.384,321.26A118.849,118.849,0,0,1,136.308,264h39.9a324.516,324.516,0,0,0,5.138,50.2Q168.435,317.155,155.384,321.26Zm10.259,13.609q9.494-2.819,18.891-4.982,3.207,14.038,7.67,27.719A120.364,120.364,0,0,1,165.643,334.869ZM248,375.671a121.547,121.547,0,0,1-35.183-7.794,298.271,298.271,0,0,1-12.623-41.254A302.426,302.426,0,0,1,248,321.765Zm0-69.86a332.354,332.354,0,0,0-50.989,5.142A307.941,307.941,0,0,1,192.2,264H248ZM248,248H192.2a308.706,308.706,0,0,1,4.8-47.084A325.631,325.631,0,0,0,248,206.191ZM232,144v-5.54a118.972,118.972,0,0,1,16-2.106v53.814a309.782,309.782,0,0,1-47.824-4.93q1.1-4.733,2.369-9.5A31.932,31.932,0,0,0,232,144ZM72,80A16.021,16.021,0,0,1,88,64H200a16.021,16.021,0,0,1,16,16v64a16.021,16.021,0,0,1-16,16H104a8,8,0,0,0-8,8v15.359L81.008,171.367A23.906,23.906,0,0,1,72,152.617Z"/><circle cx="144" cy="108" r="12"/><circle cx="188" cy="108" r="12"/><circle cx="100" cy="108" r="12"/><circle cx="368" cy="412" r="12"/><circle cx="412" cy="412" r="12"/><circle cx="324" cy="412" r="12"/></g></svg>
            </button>
          </div>
        </div>
        <!-- <div class="mt15">
          <label class="label mb5 setSubLabel">제한 후 유료 전환</label>
          <div class="checkbox">
            <input type="checkbox" id="amenity_pay" v-model="setting.pay" />
            <label for="amenity_pay">유료 전환 적용</label>
          </div>
        </div> -->
      </div>
      <!-- //기간, 횟수 -->
    </div>
    <!-- //요청 제한 -->
    <!-- 제한시 유료 전환 -->
    <div v-if="setting.integration && setting.orderLimitActive" class="innerItem">
      <div class="label mb5 setLabel">
        {{locale.switch_pay}}
        <button type="button" class="btn btnWhite sizeXs" @click="applyAll('pay')">{{locale.apply_all}}</button>
      </div>
      <p class="sysMessage">{{locale.switch_pay_message}}</p>
      <div>
        <div class="checkbox">
          <input type="checkbox" id="amenity_pay" v-model="setting.pay" />
          <label for="amenity_pay">{{locale.apply_switch}}</label>
        </div>
      </div>
    </div>
    <!-- //제한시 유료 전환 -->
    <!-- 최대 개수 -->
    <div v-if="setting.integration" class="innerItem">
      <div class="label mb5 setLabel">
        {{locale.amenity_item_max_number}}
        <button type="button" class="btn btnWhite sizeXs" @click="applyAll('max')">{{locale.apply_all}}</button>
      </div>
      <div>
        <input type="text" class="optionValue input" @input="inputNumber('max')" v-model="setting.max">
      </div>
    </div>
    <!-- //최대 개수 -->
    <!-- 어메니티 요청 가능 시간 -->
    <div class="innerItem">
      <div class="label mb5 setLabel">{{locale.page_set_available}}</div>
      <div class="mb10">
        <span class="checkbox radio">
          <input type="radio" name="amenity_available" id="amenity_available_always" value="01" v-model="setting.available.state">
          <label for="amenity_available_always">{{locale.page_available_always}}</label>
        </span>
        <span class="checkbox radio">
          <input type="radio" name="amenity_available" id="amenity_available_each" value="02" v-model="setting.available.state">
          <label for="amenity_available_each">{{locale.page_available_each}}</label>
        </span>
      </div>
      <button type="button" class="btn btnWhite btnFull" @click="setAvailableTime(true)">{{locale.setting}}</button>
    </div>
    <!-- //어메니티 요청 가능 시간 -->
    <!-- 언어별 세팅 -->
    <LangValue v-show="langValueLayer"
      :locale="locale"
      :textarea="true"
      :langValue="langValue"
      :title="locale.language_specific_set"
      @close="onLangValueClose" />
    <!-- //언어별 세팅 -->
    <AvailableTime
      v-if="availableLayer"
      :locale="locale"
      :available="setting.available"
      @apply="applyAvailableTime"
      @close="setAvailableTime(false)" />
  </div>
</template>

<script>
import regExp from '@/common/regExp'
import moment from 'moment/moment'
import SetOrder from '@/components/Amenity/SetOrder'
import Datetime from 'vue-datetime/src/Datetime.vue'
import AvailableTime from '@/components/Util/AvailableTime'
import UTIL from '@/common/util'
import LangValue from '@/components/Util/LangValue'

export default {
  props: [
    'locale'
  ],
  components: {
    SetOrder,
    Datetime,
    AvailableTime,
    LangValue
  },
  computed: {
    lang () {
      const settingData = this.$store.getters['setting/getData']
      return settingData.lang
    },
    amenity () {
      return this.$store.getters['amenity/getList']
    },
    serviceAmenity () {
      return this.$store.getters['amenity/getServiceList']
    },
    userRole () {
      return this.$store.getters['authentication/getAuthInfo'].userRole
    },
    setting: {
      get () {
        return this.$store.getters['amenity/getSetting']
      },
      set (data) {
      }
    },
    limitTime: {
      get () {
        const defaultTime = moment().set({ hour: 12, minute: 0, second: 0 }).toISOString()
        return this.setting.limitTime || defaultTime
      },
      set (data) {
        const time = moment(data).format('HH:mm')
        this.$store.commit('amenity/setLimitTime', time)
      }
    }
  },
  data () {
    return {
      order: false,
      availableLayer: false,
      langValueLayer: false,
      langValue: {},
      langTarget: ''
    }
  },
  methods: {
    onLangValueOpen (target) {
      this.langTarget = target
      this.langValueLayer = true
      this.langValue = this.setting[target]
      this.setDefaultVal(target)
    },
    onLangValueClose () {
      const target = this.langTarget
      this.setting[target] = this.langValue
      this.langValueLayer = false
      this.langValue = {}
    },
    setDefaultVal (target) {
      const defaultLang = this.lang.default
      const fillLangs = UTIL.fillLangs(this.setting[target], this.setting[target][defaultLang])
      this.setting[target] = fillLangs
    },
    setOrder () {
      if (this.serviceAmenity.length > 0) {
        this.order = !this.order
      } else {
        alert(this.locale.amenity_require_order)
      }
    },
    setAvailableTime (isOpen) {
      this.availableLayer = isOpen
    },
    applyAvailableTime (data) {
      this.setting.available = data
      this.setAvailableTime(false)
    },
    inputNumber (key) {
      const value = Number(regExp.numberOnly(this.setting[key]))
      this.setting[key] = value
    },
    applyAll (key) {
      const data = {}
      const setting = this.setting
      if (window.confirm(this.locale.amenity_apply_all)) {
        if (key === 'limit') {
          data.orderLimitActive = setting.orderLimitActive
          data.orderLimit = setting.orderLimit
          data.orderMax = setting.orderMax
        } else {
          data[key] = setting[key]
        }
        this.$store.commit('amenity/applyAll', data)
      }
    },
    validateOnSave () {
      // console.log('어메니티 저장시 체크할 것들')
      return true
    },
    onSave () {
      const isPassed = this.validateOnSave()
      if (isPassed) {
        const amenityData = this.amenity.map(x => {
          return {
            raCode: x.raCode,
            category: x.category,
            service: x.service,
            disabled: x.disabled,
            max: x.max,
            label: x.label || null,
            thumb: x.thumb || '',
            price: x.price || 0,
            pay: x.pay || false,
            orderLimitActive: x.orderLimitActive || false,
            orderLimit: x.orderLimit || '',
            orderMax: typeof (x.orderMax) === 'undefined' ? 1 : x.orderMax,
            ...x.pid && {
              pid: x.pid || null
            }
          }
        })
        const ordered = this.$store.getters['amenity/getOrder']
        const amenityCategory = this.$store.getters['amenity/getCategory']
        const amenitySetting = this.$store.getters['amenity/getSetting']
        const data = {
          list: amenityData,
          order: ordered,
          category: amenityCategory,
          setting: amenitySetting
        }
        this.$store.commit('onLoading', true)
        this.$store.dispatch('amenity/setAmenity', data)
          .then(res => {
            alert(this.locale.complete_save)
            this.$store.dispatch('amenity/getAmenity')
            this.$store.commit('onLoading', false)
          })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.limitDay {
  .checkbox label {
    display: inline-block;
  }
}
.vdatetime {
  display: inline-block;
  margin-left: 5px;
}
</style>
